import { useCallback, useState } from "react";

import { Dialog, Paragraph } from "@fronterahealth/frontera-ui-components";

import { AssessmentToolType, LearnerFileType } from "@api/graphql/types-and-hooks";
import { DocumentReviewModalInner } from "@components/DocumentReviewModal/DocumentReviewModalInner";

export interface DocumentReviewModalProps {
  fileId?: string;
  existingFiles: LearnerFileType[];
  supportedAssessments: AssessmentToolType[];
  setFileId: (fileId: string) => void;
  onClose: () => void;
}

export const DocumentReviewModal: React.FC<DocumentReviewModalProps> = ({ onClose, ...rest }) => {
  const [isDirty, setIsDirty] = useState(false);
  const [showDiscardDialog, setShowDiscardDialog] = useState(false);

  const handleClose = useCallback(() => {
    if (isDirty) {
      setShowDiscardDialog(true);
    } else {
      onClose();
    }
  }, [isDirty, onClose]);

  const handleDiscard = useCallback(() => {
    setShowDiscardDialog(false);
    setIsDirty(false);
    onClose();
  }, [onClose]);

  return (
    <>
      <Dialog
        open={!!rest.fileId}
        setOpen={() => handleClose()}
        title="Document Review"
        size="fullscreen"
        dialogClassName="m-10 max-h-[calc(100%-6rem)] overflow-hidden"
        bodyClassName="px-0! py-0! max-h-none! min-h-0! flex flex-col flex-1"
        primaryButton={undefined}
        secondaryButton={undefined}
      >
        <DocumentReviewModalInner {...rest} onDirtyChange={setIsDirty} />
      </Dialog>
      <Dialog
        open={showDiscardDialog}
        setOpen={() => {}}
        title="Unsaved Changes"
        size="xl"
        showCloseButton={false}
        primaryButton={{
          text: "Discard Changes",
          onClick: handleDiscard,
        }}
        secondaryButton={{
          text: "Keep Editing",
          onClick: () => setShowDiscardDialog(false),
        }}
      >
        <div className="py-2">
          <Paragraph size="small" colorType="primary">
            You have unsaved changes to the parsed results. If you close now, your edits will be lost.
          </Paragraph>
        </div>
      </Dialog>
    </>
  );
};
